import React, { createContext, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { db } from "../utils/firebaseConfig";
import { 
  collection, 
  doc, 
  updateDoc, 
  increment, 
  getDoc,
  addDoc,
  writeBatch 
} from "firebase/firestore";
import { signInAnonymously } from "firebase/auth";
import { auth } from "../utils/firebaseConfig";

const CarritoContext = createContext();

export function useCarrito() {
  return useContext(CarritoContext);
}

export function CarritoProvider({ children }) {
  const [carrito, setCarrito] = useState(() => {
    const guardado = localStorage.getItem("carrito");
    return guardado ? JSON.parse(guardado) : [];
  });
  const [estaMinimizado, setEstaMinimizado] = useState(false);
  const valor = {
    carrito,
    agregarAlCarrito,
    eliminarProducto,
    aumentarCantidad,
    disminuirCantidad,
    cambiarModoVenta,
    estaMinimizado,
    setEstaMinimizado,
  };

  useEffect(() => {
    signInAnonymously(auth)
      .then(() => console.log("✅ Usuario anónimo autenticado"))
      .catch(err => console.error("❌ Error al iniciar sesión anónima:", err));
  }, []);

  useEffect(() => {
    localStorage.setItem("carrito", JSON.stringify(carrito));
  }, [carrito]);

  const agregarAlCarrito = (producto) => {
    setCarrito(prev => {
      const existe = prev.find(p => p.sku === producto.sku);
      const cantidadDeseada = producto.cantidad || 1;
  
      if (existe) {
        return prev.map(p =>
          p.sku === producto.sku
            ? { ...p, cantidad: p.cantidad + cantidadDeseada }
            : p
        );
      } else {
        return [...prev, {
          sku: producto.sku,
          nombre: producto.nombre,
          descripcion: producto.descripcion,
          imagen: producto.imagen,
          cantidad: cantidadDeseada,
          modoVenta: producto.modoFardo ? "individual" : null, // 🔄 Nuevo campo
          modoFardo: producto.modoFardo || false, // 🔐 persistir bandera también
        }];
      }
    });
  };
  
  const eliminarProducto = (sku) => {
    setCarrito((prev) => prev.filter((p) => p.sku !== sku));
  };
  
  const vaciarCarrito = () => {
    setCarrito([]);
    localStorage.removeItem("carrito");
    localStorage.removeItem("carritoPagoStripe");
  };
  
  const aumentarCantidad = (sku, cantidadManual = null) => {
    setCarrito((prev) =>
      prev.map((p) =>
        p.sku === sku
          ? {
              ...p,
              cantidad:
                cantidadManual !== null
                  ? cantidadManual
                  : p.cantidad + 1,
            }
          : p
      )
    );
  };
  
  const disminuirCantidad = (sku) => {
    setCarrito((prev) =>
      prev.map((p) =>
        p.sku === sku
          ? { ...p, cantidad: Math.max(1, p.cantidad - 1) }
          : p
      )
    );
  };

  const cambiarModoVenta = (sku) => {
    setCarrito((prev) =>
      prev.map((p) =>
        p.sku === sku && p.modoFardo
          ? { ...p, modoVenta: p.modoVenta === "fardo" ? "individual" : "fardo" }
          : p
      )
    );
  };

  // Eliminamos la función calcularTotal ya que no necesitamos precios

  return (
    <CarritoContext.Provider
      value={{
        carrito,
        agregarAlCarrito,
        setCarrito,
        eliminarProducto,
        vaciarCarrito,
        aumentarCantidad,
        disminuirCantidad,
        cambiarModoVenta,
        // Eliminamos calcularTotal de los valores proporcionados
      }}
    >
      {children}
    </CarritoContext.Provider>
  );
}
